import {
  AdvertisingEvent,
  PlayerEvent,
  type PlaybackSpeedChangedEvent,
  type PlayerInterface,
} from '@foundation-player/loader';
import { readonly, writable, type Readable, type Writable } from 'svelte/store';
import type { PlayerStoreModule } from './player-store-types';

export class PlaybackSpeedPlayerStore implements PlayerStoreModule<'playbackSpeed'> {
  readonly #playbackSpeed: Writable<number> = writable(1);
  readonly playbackSpeed: Readable<number> = readonly(this.#playbackSpeed);

  initializeStateFromPlayer(player: PlayerInterface) {
    player.addEventListener(PlayerEvent.Ready, () => {
      this.#playbackSpeed.set(player.getPlaybackSpeed());
    });

    player.addEventListener(PlayerEvent.PlaybackSpeedChanged, (event: PlaybackSpeedChangedEvent) => {
      this.#playbackSpeed.set(event.playbackSpeed);
    });

    // Up to at least 1.45.0, the foundation player did not emit a
    // playbackspeedchanged event when the ad was sped up on the video element
    // directly, although the player would change the speed.
    // To improve the robustness of the player, we explicitly request the speed
    // when an ad slot ends.
    player.addEventListener(AdvertisingEvent.AdSlotCompleted, () => {
      this.#playbackSpeed.set(player.getPlaybackSpeed());
    });

    this.#playbackSpeed.set(player.getPlaybackSpeed());
  }
}
